import React, { useEffect, useState } from "react";
import { Slide, Button, Box } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { ApplicationState } from "../../store";
import * as APIStore from "../../store/APIStore";
import { Reply, Cancel } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import DiagnosisList from "../patient/DiagnosisList";
import moment from 'moment';
import { connect } from "react-redux";
import NextSiteOfCare from '../patient/NextSiteOfCare'
import { RouteComponentProps } from "react-router";
import Hidden from '@material-ui/core/Hidden';
import Paper from "@material-ui/core/Paper";
import RequestAccessToken from '../../util/authService';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { DetailedPatientStateType } from './MessagePatientLoadState'
import { refMDLoaded, practiceCoordinatorLoaded, shouldTryRefMDProfile, shouldTryCareCoordinatorProfile } from '../common/ProfileHelper'
import { formatGreetingByPractice } from './Helpers'
import AssignedProviderDisplay from './AssignedProviderDisplay'

export interface DirectProps {
    message: APIStore.Message,
    userRefMdProfile: APIStore.RefMdProfile
}

type DischargeNotificationProps = APIStore.HNIContextState &
    typeof APIStore.actionCreators &
    RouteComponentProps<{ MessageId: string }> &
    DirectProps

const formatDate = (date) => {
    if (!date) {
        return null;
    }

    let dt = moment(date);

    return (dt.hours() === 0 && dt.minutes() === 0 && dt.seconds() === 0 ? dt.format('MM/DD/YYYY') : dt.format('hh:mm:ss A MM-DD-YYYY'));
}

const DischargeNotificationItem = (props: DischargeNotificationProps) => {
    let {
        userRefMdProfile,
        userPracticeCoordinatorProfile,
        requestVitalsMdProfile,
        clearSentMessageState,
        requestProviderMessage,
        requestConsolidatedPatientById,
        requestCurrentUserCareCoordinatorProfile,
        markMessageAsRead,
        FocusPatient } = props;

    let Patients = props.Patients;
    let Messages = props.Messages;

    let [tokenState, setTokenState] = useState<APIStore.TokenType>();
    let initial: DetailedPatientStateType = {
        patient: undefined,
        isLoaded: false,
        isLoading: false
    };

    let [detailedPatientState, setDetailedPatientState] = useState<DetailedPatientStateType>(initial);
    let [userGreetStr, setUserGreetStr] = useState<string>();
    let [readNotification, setReadNotification] = useState(false);

    let tokenStatePr = RequestAccessToken()
        .then((token) => {
            if (token && !tokenState) {
                setTokenState(token);
            }
        });

    let messageId = parseInt(props.match?.params.MessageId) || 0;

    let { Errors, SendMessageState, failedLoading, FocusMessage, isLoaded: MessagesQueueLoaded } = Messages;

    useEffect(() => {
        if (tokenState?.accessToken && messageId > 0) {
            requestProviderMessage(tokenState.accessToken, messageId);
        }
    }, [tokenState, messageId]);



    useEffect(() => {
        if (shouldTryRefMDProfile(userRefMdProfile) && tokenState?.accessToken && userPracticeCoordinatorProfile.notFound) {
            requestVitalsMdProfile(tokenState.accessToken);
        }

    }, [tokenState, userRefMdProfile, userPracticeCoordinatorProfile])

    useEffect(() => {
        let patientEncounterId: number = FocusMessage?.message?.ptId;
        if (FocusMessage?.messageId === messageId) {
            if (tokenState?.accessToken && !detailedPatientState?.isLoaded && !detailedPatientState.isLoading && patientEncounterId) {
                requestConsolidatedPatientById(patientEncounterId, tokenState.accessToken);
                setDetailedPatientState({
                    ...detailedPatientState,
                    isLoading: true
                })
            }


            if (detailedPatientState.isLoading) {
                if (FocusPatient?.patient?.patientEncounterId) {
                    setDetailedPatientState({ isLoaded: true, isLoading: false, patient: FocusPatient?.patient })
                }
            }

        }

    }, [tokenState, detailedPatientState.patient, Patients, FocusMessage?.messageId]);

    useEffect(() => {
        if (shouldTryCareCoordinatorProfile(userPracticeCoordinatorProfile) && tokenState?.accessToken) {
            requestCurrentUserCareCoordinatorProfile(tokenState.accessToken);
        }
    }, [tokenState, userRefMdProfile, userPracticeCoordinatorProfile]);

    useEffect(() => {
        if (tokenState?.accessToken) {

            if (practiceCoordinatorLoaded(userPracticeCoordinatorProfile)) {
                setUserGreetStr(`Attention: ${userPracticeCoordinatorProfile.coordinatorProfile.defaultPractice.practiceName}`)
            }

            if (refMDLoaded(userRefMdProfile)) {
                setUserGreetStr(`Dear Dr. ${userRefMdProfile.refmdProfile.lastName}`);
            }
        }
    }, [tokenState, userRefMdProfile, userPracticeCoordinatorProfile]);

    const history = useHistory();

    if (!FocusMessage?.messageId || !userGreetStr || !detailedPatientState?.isLoaded) {
        return (
            <div className="maincontent">
                <Paper elevation={1} style={{ padding: 50 }}>

                    <Grid container spacing={8} className="noticebar"
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        <Grid item>
                            <Button startIcon={< Reply />} disabled={true}>
                                <Hidden xsDown>
                                    Reply
                                </Hidden>
                            </Button>

                            <Button startIcon={< Cancel />} disabled={true}>
                                <Hidden xsDown>
                                    Cancel
                                </Hidden>
                            </Button>
                        </Grid>
                    </Grid>
                    <Box m={4}>
                        <Grid container direction="row" spacing={4}>
                            <Grid item xs={4}>
                                <div className="animate-flicker"><p className="skeleton">&#8239;&#8239;&#8239;&#8239;</p></div>
                                <div className="animate-flicker"><p className="skeleton">&#8239;&#8239;&#8239;&#8239;</p></div>
                            </Grid>

                        </Grid>
                        <Grid item xs={12}>
                            <p className="animate-flicker">Loading...</p>
                        </Grid>
                    </Box>

                </Paper>
            </div>
        )
    }


    let message = FocusMessage?.message;


    let { patientEncounterId, lastName, firstName, dateOfBirth } = detailedPatientState.patient;

    let { encounters } = detailedPatientState.patient;

    let encounter: APIStore.Encounter = encounters[0];

    let {
        patientDiagnosisList,
        primaryProviderContact,
        encounterEnd,
        pcpFromRosterContact,
        facility, nextSiteOfCare, dischargingPhysician, referringMD } = encounter;



    let { facilityName } = facility;

    let { displayName, email } = primaryProviderContact;

    let assignedProviderFormatted = "";
    let dischargeProviderFormatted = "";
    if (!primaryProviderContact.type.toLocaleLowerCase().startsWith('program')) {
        assignedProviderFormatted = displayName;
    }

    if (dischargingPhysician) {
        dischargeProviderFormatted = dischargingPhysician.displayName;
    } else {
        dischargeProviderFormatted = "";
    }


    const goBack = () => {
        history.goBack();
    };

    const handleReply = () => {

        let replyMessage = {
            ...message,
            messageType: null,
            senderId: email,
            patient: {
                ...message.patient
            }
        }

        history.push("/notification-reply", { message: replyMessage });
    };

    const handleCloseSnack = () => {
        isSent = false;
        messageSent = false;
        sentMessageSubject = '';
        clearSentMessageState();
    }

    let isSent, isErrored = null;
    let messageSent = false;
    let sentMessage = '';

    if (SendMessageState) {
        let { isSent, message, isErrored } = SendMessageState;
        messageSent = isSent;
        sentMessage = message;
    }

    let generalErrorMessage = '';
    if (Errors && Errors.length) {
        let generalError = Errors.filter(val => val.messageId < 1)[0];
        generalErrorMessage = generalError.error;
    }

    let sentMessageSubject = '';
    if (sentMessage && sentMessage.subject) {
        sentMessageSubject = sentMessage.subject;
    }

    if (tokenState && tokenState.accessToken && !readNotification) {
        markMessageAsRead(tokenState.accessToken, message);
        setReadNotification(true);
    }

    return (
        <React.Fragment>
            <Slide in timeout={1000} direction="left">
                <div>

                    <Grid container spacing={8} className="noticebar"
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center">

                        <Grid item>
                            <Button startIcon={< Reply />} onClick={() => handleReply()}>
                                <Hidden xsDown>
                                    Reply
                                </Hidden>
                            </Button>
                            <Button onClick={goBack}>
                                <Cancel /> Cancel
                            </Button>
                        </Grid>
                    </Grid>
                    <Box sx={{ padding: '1em' }}>

                        <Grid container direction="row" spacing={4}>
                            <Grid item xs={12}>
                                <div>From: VitalsMD&trade; Discharge notification on behalf of{" "}
                                    {assignedProviderFormatted}   </div>
                                <div>Subject: <strong>{message.subject}</strong></div>
                                <div>Date: <strong>{formatDate(message.createdDate)}</strong></div>
                            </Grid>
                            <Grid item xs={12}>
                                <p>
                                    {
                                        formatGreetingByPractice(userGreetStr, userPracticeCoordinatorProfile.coordinatorProfile.defaultPractice, pcpFromRosterContact, referringMD)
                                    }
                                </p>
                            </Grid>
                            <Grid item xs={12}>
                                <p>The following patients have been discharged:
                                    <strong>{` ${lastName}`}, {firstName}</strong> at {facilityName} on {formatDate(encounterEnd)}</p>
                                <p>Date of Birth: {formatDate(dateOfBirth)}</p>
                                <AssignedProviderDisplay name = {assignedProviderFormatted}  title = 'Assigned Provider'/>
                                <AssignedProviderDisplay name = {dischargeProviderFormatted}  title = 'Discharging Provider'/>
                            </Grid>
                            <Grid item xs={12}>
                                <DiagnosisList listLabel='Diagnosis History' diagnosisCodes={patientDiagnosisList} />
                            </Grid>
                            <Grid item xs={12} >
                                <NextSiteOfCare nextSiteOfCare={nextSiteOfCare} />
                            </Grid>


                            <Grid item xs={12}>
                                <p>Our goal is to provide the highest quality care and maintain open communication with the
                                    primary care physicians of our patients. We believe communication is essential in
                                    providing your patient with continuity of care and the best possible outcomes.
                                    Once your patient is discharged, you will be provided a discharge summary and any
                                    other pertinent information you should need. In addition, you are welcome to contact us
                                    any time if you have any questions or concerns about your patient or our hospitalist
                                    program.</p>
                            </Grid>
                            <Grid item xs={12}>
                                <strong>
                                    <p>Respectfully,</p>
                                    <p>HNI Healthcare
                                        Hospitalists Group</p>
                                </strong>


                            </Grid>

                        </Grid>

                    </Box>
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }} autoHideDuration={6000}

                        action={
                            <React.Fragment>
                                <Button color="secondary" size="small" onClick={() => handleCloseSnack()}>
                                    CLOSE
                                </Button>
                                <IconButton size="small" aria-label="close" color="inherit" onClick={() => handleCloseSnack()}>
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            </React.Fragment>
                        }

                        open={messageSent && !isErrored} message={`Message Sent: ${sentMessageSubject}`
                        } />
                </div>

            </Slide>

        </React.Fragment>
    )
}

export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(DischargeNotificationItem as any);